import { createQueryKeys } from "@lukemorales/query-key-factory";

import { floorApi } from "~/api";

import { getWhitePlanFile } from "./helpers/plan.helper";

/**
 * The contract returns `null` for a floor that has no plan yet; showing a blank sheet instead is an
 * app decision, so the substitution lives here rather than in `@eisox/api`.
 */
export const floorPlanQueries = createQueryKeys("floorPlan", {
  byId: (floorId: string) => ({
    queryKey: [floorId],
    queryFn: async (): Promise<File> => (await floorApi.plan(floorId)) ?? getWhitePlanFile(floorId),
  }),
});
